import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Fieldset } from '@millionshow/client-libs';
import { EventDto } from '@millionshow/api-client';

@Component({
  selector: 'app-booth-info',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, Fieldset],
  template: `
    <div [formGroup]="form()" class="flex flex-col gap-6">
      <h2 class="text-lg font-semibold text-zinc-800">참가신청 정보</h2>

      <app-fieldset label="참가행사" required>
        <select formControlName="eventId" class="select cursor-pointer w-full">
          <option value="">선택해주세요</option>
          @for (event of events(); track event.id) {
          <option [value]="event.id">{{ event.title }}</option>
          }
        </select>
      </app-fieldset>

      <app-fieldset class="relative" label="기타문의" required="false">
        <textarea
          formControlName="inquiry"
          class="input w-full min-h-[100px]"
          placeholder="입력해주세요"
          maxlength="500"
          style="white-space: normal"></textarea>
        <div class="absolute bottom-4 right-2 text-sm text-zinc-300 z-10">
          {{ form().get('inquiry')?.value?.length || 0 }}/500
        </div>
      </app-fieldset>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class BoothInfoComponent {
  form = input.required<FormGroup>();
  events = input<EventDto[]>([]);
}
